import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "fileType-file",
  "use": "fileType-file-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"fileType-file\"><defs><symbol id=\"fileType-file_file-unknow\" data-name=\"file-unknow\" viewBox=\"0 0 20 20\"><path d=\"M15.77,0H0V20H20V4.23ZM12,13.16H5.68V12.11H12Zm2.11-2.53H5.68V9.58h8.42Zm0-2.53H5.68V7.05h8.42Zm1.67-3.74V.28l4.08,4.08Z\" fill=\"#ff9200\" fill-rule=\"evenodd\" /></symbol></defs><title>fileType-file</title><g id=\"fileType-file_图层_2\" data-name=\"图层 2\"><g id=\"fileType-file_图层_1-2\" data-name=\"图层 1\"><use width=\"20\" height=\"20\" xlink:href=\"#fileType-file_file-unknow\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/fileType-file.svg
// module id = HwBL
// module chunks = 264